const rawBaseUrl = process.env.REACT_APP_PHP_BASE_URL;
export const PHP_BASE_URL = rawBaseUrl ? rawBaseUrl.replace(/\/$/, '') : '';
